<label (click)="toggle($event)" [class.disabled]="disabled">
  <mat-checkbox
    [class.min]="isSmall"
    [color]="color"
    [disabled]="disabled"
    [checked]="value"
  ></mat-checkbox>
  <div class="text">
    <ng-content></ng-content>
  </div>
</label>
